import "./App.css";
import Home from "./component/Home";
import { Box } from "@mui/material";

function App() {
  return (
    <Box className="App" id="/">
      <Home />
    </Box>
  );
}

export default App;
